var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.40093 8.41649L2.40084 17.9408C2.40083 19.0454 3.29626 19.9408 4.40084 19.9408L19.5996 19.9409C20.7041 19.9409 21.5995 19.0455 21.5996 17.9409L21.5999 8.01226C21.5999 7.45996 21.1522 7.01223 20.5999 7.01223H12.0836L9.31857 4.05859H3.40028C2.84785 4.05859 2.40007 4.50581 2.40024 5.05824C2.40055 6.00905 2.40094 7.43597 2.40093 8.41649Z",
    stroke: "#4F4D55",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.668bcd1aa8195a7c207ec799b385105e.svg";
export { ForwardRef as ReactComponent };